import { render, staticRenderFns } from "./RecognitionCreate.vue?vue&type=template&id=62176f3f"
import script from "./RecognitionCreate.vue?vue&type=script&lang=js"
export * from "./RecognitionCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports